<template>
    <div class="vld-parent">
    <loading 
        :active.sync="loading" 
        :can-cancel="false" 
        :is-full-page="true"
        color="#042333"
        :width="150"
        :height="150"
        loader="bars"
    >
    </loading>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import axios from "axios";
    export default {
        components: {
            Loading
        },
        computed:{
            loading(){
                return this.$store.state.loading.isLoading;
            }
        },
        watch:{
            loading: function(){
                if(this.loading){
                    axios.all(this.$store.state.loading.requisicoes)
                    .then(() => {
                        this.$store.dispatch("loading/resetRequisicoes");
                        this.$store.dispatch("loading/habilitarLoading",false);
                    });
                }
            }
        },
        mounted(){
            axios.all(this.$store.state.loading.requisicoes)
            .then(() => {
                this.$store.dispatch("loading/resetRequisicoes");
                this.$store.dispatch("loading/habilitarLoading",false);
            });
        }
    }
</script>